export const generalSettingState = {
    errorCode : 0,
    statusCode : 0,
    allSetting : [],
    message : '',
    responseValue : ''
}